import Immutable from 'immutable';
import _         from 'lodash';

import DefaultParameters      from './DefaultParameters';
import DefaultBomParameters   from './DefaultBomParameters';
import DefaultQuote           from './DefaultQuote';

import {
  numberValidation,
  quantitiesValidation,
  bomParametersValidation,
  bomPartsValidation,
}from "pu-data/Validations.js";
import { START, PRICE_SELECTED } from "../../shared/pu-data/QuoteSteps";

const state = {
  name: 'PCB Parts',
  code: 'pcbparts',
  provideParts : false,
  parameters: DefaultParameters,
  quote: DefaultQuote,
  workbook: [],
  bomStep : 1,
  bomParameters: DefaultBomParameters,
  bomId: null,
  bomQuoteNumber: null,
  price: null,
  itemSelected: false,
  loading: false,
  selectedQuantity: null, 
  showModal: false,
  showSummary: false,
  errors: {},
  quoteStep: START,
  focusOfferID: null,
  substituteParts: [],
  possibleOption: [],
  possibleSustitutes: [],
  filter: null,
};

export const validateBomParametersRules = {
  first_row: name => numberValidation('1st Data Row', name),
};

export const aditionalBomRules = {
  quantities: quantitiesValidation,
  bom_parameters: bomParametersValidation,
  bom_parts: bomPartsValidation,
};

// if (Spree.items_quote && Spree.items_quote[parts_item_id]) {
//   const data = Spree.items_quote[parts_item_id]
//   state.quote = data

//   state.parameters = Spree.items_parameters[parts_item_id]

//   state.showSummary = true
//   state.itemSelected = true
//   state.quoteStep = PRICE_SELECTED
//   state.selectedQuantity = data.selected_quantity
//   state.bomQuoteNumber = data.bom_quote_number
// }

export default state;
